import { SET_SEARCH_FORM_FULL_SCREEN } from './actionTypes';

export const setSearchFormFullScreen = (state) => ({
  type: SET_SEARCH_FORM_FULL_SCREEN,
  state
})


